import React, { useEffect, useState } from "react";
import { getCouponsService, patchRequest } from "../../../services/apiService";
import ReactDOM from "react-dom";
import "../styles/Coupons.css";

const DisplayCoupons = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingCoupon, setEditingCoupon] = useState(null);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    fetchCoupons();
  }, []);

  useEffect(() => {
    if (editModalOpen) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [editModalOpen]);

  const fetchCoupons = async () => {
    try {
      const res = await getCouponsService();
      setCoupons(res.Data || []);
    } catch (err) {
      console.error("Error fetching coupons", err);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (coupon) => {
    setEditingCoupon({ ...coupon });
    setEditModalOpen(true);
  };

  const handleSaveEdit = async () => {
    if (!editingCoupon) return;
    try {
      await patchRequest(`/Coupons/${editingCoupon.cid}`, editingCoupon);
      alert("Coupon updated successfully!");
      setEditModalOpen(false);
      setEditingCoupon(null);
      fetchCoupons();
    } catch (err) {
      console.error(err);
      alert("Failed to update coupon");
    }
  };

  const totalPages = Math.ceil(coupons.length / pageSize);
  const paginatedCoupons = coupons.slice((page - 1) * pageSize, page * pageSize);

  if (loading) return <div style={{ padding: "20px" }}>Loading coupons...</div>;

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ color: "#0f9d58", marginBottom: "15px" }}>Display Coupons</h2>

      {/* Table */}
      <div style={{ overflowX: "auto" }}>
        <table className="coupons-table">
          <thead>
            <tr>
              {[
                "#",
                "Coupon ID",
                "Amount",
                "No of Times",
                "Valid From",
                "Valid To",
                "Created By",
                "Min Order",
                "Discount %",
                "Max Discount",
                "Description",
                "Active",
                "Actions",
              ].map((h) => (
                <th key={h}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginatedCoupons.map((c, index) => (
              <tr key={c.cid}>
                <td style={{color :"black"}}>{(page - 1) * pageSize + index + 1}</td>
                <td style={{color :"black"}}> {c.couponid}</td>
                <td style={{color :"black"}}>{c.amount}</td>
                <td style={{color :"black"}}>{c.notimes}</td>
                <td style={{color :"black"}}>{c.validfrom}</td>
                <td style={{color :"black"}}>{c.validto}</td>
                <td style={{color :"black"}}>{c.created_by}</td>
                <td style={{color :"black"}}>{c.minordervalue}</td>
                <td style={{color :"black"}}>{c.disp}</td>
                <td style={{color :"black"}}>{c.maxdisvalue}</td>
                <td style={{color :"black"}}
                  dangerouslySetInnerHTML={{
                    __html: c.coupondesc?.replace(/\n/g, "<br/>"),
                  }}
                />
                <td style={{color :"black"}}>
                  <input
                    type="checkbox"
                    checked={c.active}
                    readOnly
                    style={{ cursor: "not-allowed" }}
                  />
                </td>
                <td style={{color :"black"}}>
                  <button onClick={() => handleEdit(c)} className="btn-edit">
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ---------- PAGINATION ---------- */}
     
<div className="pagination-container">


<div style={{color:"black"}}>

<select
className="page-select"
value={pageSize}
onChange={(e) => {
setPageSize(Number(e.target.value));
setPage(1);
}}
>

{[5,10,20,50].map((n)=>(
<option key={n} value={n}>
{n}
</option>
))}

</select>

</div>



<div className="page-buttons">

<button
className="page-btn"
disabled={page===1}
onClick={()=>setPage(page-1)}
>
Previous
</button>


<span className="page-count">

{page} / {totalPages || 1}

</span>


<button
className="page-btn"
disabled={page===totalPages || totalPages===0}
onClick={()=>setPage(page+1)}
>
Next
</button>

</div>


</div>

      {/* ---------- EDIT MODAL ---------- */}
      {editModalOpen &&
        editingCoupon &&
        ReactDOM.createPortal(
          <>
            <div className="modal-overlay">
              <div className="modal-content">
                <h3>Edit Coupon: {editingCoupon.couponid}</h3>

                <div className="modal-grid">
                  <div>
                    <label>Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      value={editingCoupon.amount}
                      onChange={(e) =>
                        setEditingCoupon({ ...editingCoupon, amount: e.target.value })
                      }
                    />
                  </div>
                  <div>
                    <label>No of Times</label>
                    <input
                      type="number"
                      className="form-control"
                      value={editingCoupon.notimes}
                      onChange={(e) =>
                        setEditingCoupon({ ...editingCoupon, notimes: e.target.value })
                      }
                    />
                  </div>
                  <div>
                    <label>Valid From</label>
                    <input
                      type="date"
                      className="form-control"
                      value={editingCoupon.validfrom}
                      onChange={(e) =>
                        setEditingCoupon({ ...editingCoupon, validfrom: e.target.value })
                      }
                    />
                  </div>
                  <div>
                    <label>Valid To</label>
                    <input
                      type="date"
                      className="form-control"
                      value={editingCoupon.validto}
                      onChange={(e) =>
                        setEditingCoupon({ ...editingCoupon, validto: e.target.value })
                      }
                    />
                  </div>
                  <div>
                    <label>Min Order Value</label>
                    <input
                      type="number"
                      className="form-control"
                      value={editingCoupon.minordervalue}
                      onChange={(e) =>
                        setEditingCoupon({ ...editingCoupon, minordervalue: e.target.value })
                      }
                    />
                  </div>
                  <div>
                    <label>Discount %</label>
                    <input
                      type="number"
                      className="form-control"
                      value={editingCoupon.disp}
                      onChange={(e) =>
                        setEditingCoupon({ ...editingCoupon, disp: e.target.value })
                      }
                    />
                  </div>
                  <div>
                    <label>Max Discount</label>
                    <input
                      type="number"
                      className="form-control"
                      value={editingCoupon.maxdisvalue}
                      onChange={(e) =>
                        setEditingCoupon({ ...editingCoupon, maxdisvalue: e.target.value })
                      }
                    />
                  </div>
                  <div>
                    <label>Active</label>
                    <input
                      type="checkbox"
                      checked={editingCoupon.active === 1}
                      onChange={(e) =>
                        setEditingCoupon({
                          ...editingCoupon,
                          active: e.target.checked ? 1 : 0,
                        })
                      }
                    />
                  </div>
                </div>

                <div>
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    value={editingCoupon.coupondesc}
                    onChange={(e) =>
                      setEditingCoupon({ ...editingCoupon, coupondesc: e.target.value })
                    }
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "15px",
                    gap: "10px",
                  }}
                >
                  <button
                    onClick={() => setEditModalOpen(false)}
                    className="btn-cancel"
                  >
                    Cancel
                  </button>
                  <button onClick={handleSaveEdit} className="btn-save">
                    Save Changes
                  </button>
                </div>
              </div>
            </div>

            {/* -------- MODAL STYLES -------- */}
            <style>{`
              .modal-overlay {
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100vh;
                background: rgba(0, 0, 0, 0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 9999;
              }
              .modal-content {
                background: #fff;
                padding: 20px;
                border-radius: 10px;
                max-width: 700px;
                width: 90%;
                max-height: 90vh;
                overflow-y: auto;
                box-shadow: 0 4px 15px rgba(0,0,0,0.2);
              }
              .modal-grid {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                gap: 15px;
                margin-bottom: 15px;
              }
              .modal-grid label {
                font-weight: bold;
                display: block;
                margin-bottom: 5px;
              }
              .form-control {
                width: 100%;
                padding: 5px 8px;
                border: 1px solid #ccc;
                border-radius: 5px;
                font-size: 14px;
              }
              .btn-save {
                background-color: #0f9d58;
                color: #fff;
                border: none;
                padding: 8px 12px;
                border-radius: 5px;
                cursor: pointer;
              }
              .btn-cancel {
                background-color: #ccc;
                color: #000;
                border: none;
                padding: 8px 12px;
                border-radius: 5px;
                cursor: pointer;
              }
              .btn-save:hover {
                background-color: #0b7a43;
              }
              .btn-cancel:hover {
                background-color: #aaa;
              }
            `}</style>
          </>,
          document.body
        )}
    </div>
  );
};

export default DisplayCoupons;
